import { useCallback, useEffect, useMemo, useState } from 'react'
const isServerSide = typeof window === 'undefined'
const useSearchHistory = (keyPath = '') => {
  const historyPath = keyPath || 'search_history'
  const initHitory = useMemo(() => {
    if (isServerSide) {
      return []
    } else {
      return JSON.parse(localStorage.getItem(historyPath) ?? '[]')
    }
  }, [isServerSide])
  const [searchHistories, setSearchHistories] = useState(initHitory)

  useEffect(() => {
    localStorage.setItem(historyPath, JSON.stringify(searchHistories))
  }, [searchHistories])

  const addHistory: (string) => void = useCallback(
    (newHistory) => {
      if (!newHistory?.length) {
        return
      }
      const currentIndex = searchHistories.indexOf(newHistory)
      if (currentIndex === 0) {
        return
      } else if (currentIndex > 0) {
        // if exists move to first
        const leftOthers = [...searchHistories]
        leftOthers.splice(currentIndex, 1)
        setSearchHistories([newHistory, ...leftOthers])
      } else {
        const newHistories = [newHistory, ...searchHistories]
        if (newHistories.length > 10) {
          newHistories.length = 10
        }
        setSearchHistories(newHistories)
      }
    },
    [searchHistories, setSearchHistories]
  )

  // 清除搜索历史
  const removeHistory = useCallback((val) => {
    if (val) {
      try {
        const newHistories = searchHistories.filter((item) => item !== val)
        setSearchHistories(newHistories)
        // console.log('removeHistory', { val, newHistories, searchHistories })
      } catch (error) {
        console.error('Error removing search history:', error)
      }
    }
  }, [searchHistories])


  // get search history
  const getSearchHistory = useCallback(() => {
    if (isServerSide) {
      return []
    } else {
      const storedHistories = localStorage.getItem(historyPath)
      return storedHistories ? JSON.parse(storedHistories) : []
    }
  }, [historyPath])

  return [searchHistories, addHistory, removeHistory, getSearchHistory]
}

export default useSearchHistory
